import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TagsService {
  private readonly tags: BehaviorSubject<
    { name: string; identifier: string }[]
  > = new BehaviorSubject<{ name: string; identifier: string }[]>([]);

  constructor() {}

  getTags(): Observable<{ name: string; identifier: string }[]> {
    return this.tags.asObservable();
  }

  setTags(data: { name: string; identifier: string }[]) {
    this.tags.next(data);
  }

  getTagByIdentifier(
    identifier: string
  ): { name: string; identifier: string } | undefined {
    return this.tags.getValue().find((tag) => tag.identifier === identifier);
  }
}
